<template>
  <div class="works-view">
    <works-com :data-list="studentWorkList" @ScrollCreate="ScrollCreate" @pullingUp="scrollTarget">
      <template v-slot:workShow="ctx1">
        <div class="foot-box">
          <div class="state">
            <div class="state-left-text">
              <div v-if="ctx1.data.item.cmnt" class="result"> 已批改 </div>
              <div v-else class="reject"> 未批改 </div>                    
            </div>
            <div class="state-right-text" @click="setState(ctx1.data.item, ctx1.data.index)">
              <div v-if="ctx1.data.item.status" class="show"> 已展示 </div>
              <div v-else class="hide"> 展示 </div>                    
            </div>
          </div>
          <div v-if="ctx1.data.item.comments.length" class="comments">
            <div v-for="(item_com, index_com) in ctx1.data.item.comments" :key="'com'+index_com" class="comment">
              <div class="picture"> <img :src="item_com.pic" alt=""> </div>
              <div class="com-name"> {{ item_com.name }}:</div>
              <div class="com-text"><div> {{ item_com.comment }} </div> <div class="com-text-time"> {{ item_com.time }} </div></div>
            </div>
          </div>
          <div class="leave-message" @click="showCommentBox(ctx1.data.item, ctx1.data.index)">
            <div class="box-input">
              评论
            </div>
          </div>
        </div>
      </template>
      <template v-slot:foot>
        <div class="view-hide" v-show="commetnBoxShow">
          <div class="bg" @touchstart="commetnBoxShow = false"></div>
          <message-book :text="'发送'" v-model="commentText" @btn="pushComment" :showfocus="showfocus" class="message-box"/>
        </div>
      </template>
    </works-com>
  </div>
</template>

<script>
  import { getArticleList, workShow, addComment } from '@api/article'
  import MessageBook from '@components/common/textBox/messageBook/MessageBook'
  import worksCom from '@components/content/workBox/worksCom'

  export default {
    name: 'Ss',
    components: { 
      MessageBook,
      worksCom
    },
    data() {
      return {
        studentWorkList: [],
        limit: 10,
        page: 1,
        commetnBoxShow: false,
        showfocus: true,
        scroll: null
      }
    },
    methods: {
      getStudentListData() {
        let param = { page: this.page, limit: this.limit }
        getArticleList(this.$route.params.uid, param).then(res => {
          let result = res.data;
          if (result.length) {
            for (let item of result) {
              this.studentWorkList.push({
                id: item.id,
                name: item.student_name,
                pic: item.headimgurl || require('@assets/images/1.jpg') ,
                title: item.title,
                evalPic: item.slider_image,
                time: item.add_time,
                praise: item.flowers,
                praise_state: item.isflower,
                stars: item.stars,
                visit: Number(item.visit),
                status: item.status,
                cmnt: item.cmnt,
                comments: this.newEeply(item.reply),
                commentText: ''
              })             
            }

            this.page++; //获取到数据，下次操作
            if (this.scroll) {
              this.scroll.refresh();
              this.scroll.finishPullUp();
            }
          }else {
            this.$Message.success('已经到底啦');
          }
        })        
      },
      setState(data, index) { //展示作品
        let id = data.id;
        if (id) {
          this.studentWorkList[index].status = !this.studentWorkList[index].status;
          workShow(id).then(res => {
            if (res.status === 200) {
              if (this.studentWorkList[index].status) {
                this.$Message.success('作品展示');
              }else {
                this.$Message.success('作品关闭');
              }
            }
          })
        }
      },
      pushComment() { //发送评论
        this.commetnBoxShow = false;
        if (!this.commentText) {
          return this.$Message.success('请输入评论内容');
        }else if (!this.commentData){
          return this.$Message.success('未选中作品');
        }else {
          let form = {
            article_id: this.commentData.id, 
            comment: this.commentText, 
            stars: 0, //默认评星为0 取消评星功能
          }
          addComment(form).then(res => {
            if (res.status === 200) {
              this.$Message.success('评论成功');
              this.studentWorkList.splice(0, this.studentWorkList.length);
              this.page = 1; //重新加载数据

              this.getStudentListData();
              if (this.scroll) {
                this.scroll.scrollTo(0,0,0); 
                this.scroll.finishPullUp(); 
              }

            }
          })
        }
      },
      showCommentBox(item, index) { //评论框弹出
        this.commetnBoxShow = true;
        this.currindex = index;
        this.commentText = "";
        this.commentData = null;
        let id = item.id;
        if (id) {
          if (this.studentWorkList[index].commentText) {
            this.commentText = this.studentWorkList[index].commentText;
          }
          this.commentData = item;
        }
      },
      newEeply(reply) { //新reply
        let arr = [];
        if (reply && Array.isArray(reply) && reply.length) {
          arr = reply;
        }else if (reply && typeof(reply) === 'object') {
          for (let prop in reply) {
            let item = reply[prop];
            arr.push({
              name: item.nickname,
              pic: item.headimgurl || require('@assets/images/1.jpg'),
              comment: item.comment,
              time: item.add_time,
              uid: item.uid
            });
          }
        }
        return arr;
      },
      scrollTarget() { //接受上拉操作
        this.getStudentListData();
      },
      ScrollCreate(scroll) { //复制scroll
        this.scroll = scroll;
      }
    },
    mounted() {
      this.getStudentListData();
    },
    watch: {
      commetnBoxShow: {
        handler(newVlaue) {
          if (!newVlaue) {
            this.studentWorkList[this.currindex].commentText = this.commentText;
          }else {
            this.showfocus = !this.showfocus;
          }
        },
        deep: true,
      }
    }
  }
</script>

<style scoped>
  .works-view {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #f5f5f5;
    padding: 0 0.2rem;
  }
    .wrapper {
      height: 100vh;
      overflow: hidden;
    }
      .content {
        padding-bottom: 2rem;
      }
        .evaluate-item {
          width: 100%;
          background-color: white;
          border-radius: 0.15rem;
          margin-top: 0.3rem;
        }
          .user-info {
            padding: 0.3rem;
            width: 100%;
          }
        .show-box {
          display: flex;
          align-items: center;
        }
        .show-content {
          width: 100%;
        } 
          .state{
            display: flex;
            justify-content: space-between;
            margin: 0.1rem 0;
            letter-spacing: 0.02rem;
          }
            .state-left-text {
              margin-left: 0.1rem;
            }
              .result {
                color: #5d8db7;
              }
              .reject {
                color: #c36b73;
              }
            .state-right-text {
              margin-right: 0.1rem;
            }
              .show {
                background-color: #c8bcf9;
                padding: 0 0.1rem;
                border-radius: 0.1rem;
                color: white;
              }
              .hide {
                background-color: #e46a6a;
                padding: 0 0.1rem;
                border-radius: 0.1rem;
                color: white;
              }
            .comments {
              margin-top: 0.1rem;
              padding-top: 0.05rem;
              border-top: 1px solid #d4d4d4;
            }
              .comment {
                display: flex;
                margin-top: 0.1rem;
              }
                .com-name {
                  margin-right: 0.1rem;
                  font-size: 0.3rem;
                }
                .picture {
                  margin-right: 0.2rem;
                }
                  .picture img {
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                  }
                .com-text {
                  color: #97999a;
                }
                  .com-text-time {
                    color: #98bee0;
                  }
                  .box-input {
                    background-color: #eeeaf1;
                    padding: 0.1rem 0.2rem;
                    border-radius: 0.1rem;
                    color: #777c80;
                  }
    .view-hide {
      position: absolute;
      width: 100vw;
      height: 100vh;
      z-index: 99;
      background-color: rgba(0, 0, 0, 0);
      left: 0;
      top: 0;
      display: flex;
    }
      .bg {
        flex: 1;
      }
      .message-box {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        height: 1rem;
      }
</style>